import defaultTheme from '../themes/default.js';
function _stringify(val) {
  return val ? JSON.stringify(val) : '';
}
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
export function isEqual(a, b) {
  return _stringify(a).localeCompare(_stringify(b)) === 0;
}
export function compare(a, b) {
  return _stringify(a).localeCompare(_stringify(b));
}
export function createUUID() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
export function createID() {
  return s4() + s4();
}
export function arrayEquals(a, b) {
  if (!a && !b) return true;
  return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => isEqual(val, b[index]));
}
export function checkPasswordConstraints(pass) {
  const constraints = {
    length: !!(pass && pass.length >= 8),
    digit: /\d/.test(pass),
    // lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    special: /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g.test(pass)
  };
  return constraints;
}
export function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}
export function getDeepValue(source, field) {
  let sourceObject = source;
  let fieldName = field.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  fieldName = fieldName.replace(/^\./, ''); // strip a leading dot
  const path = fieldName.split('.');
  for (let i = 0, n = path.length; i < n; i += 1) {
    const partName = path[i];
    if (sourceObject && partName in sourceObject) {
      sourceObject = sourceObject[partName];
    } else {
      return null;
    }
  }
  return sourceObject;
}
export function setTheme(theme) {
  Object.keys(theme).forEach(key => document.documentElement.style.setProperty(key, theme[key]));
}
export function setFallbackTheme() {
  const primary = getComputedStyle(document.documentElement).getPropertyValue('--primary');
  if (!primary) {
    // eslint-disable-next-line
    console.warn('setting fallback theme to skeletor UI');
    setTheme(defaultTheme);
  }
}